import React from 'react';

import { CircularProgress } from '@material-ui/core';

import Button from '../../../../../../../form/button';

export interface IProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;

  onPress?: () => void;
}

const DialogFooterButton: React.FC<React.PropsWithChildren<IProps>> = ({
  className,
  children,
  disabled,
  loading,
  onPress: pOnPress
}) => {
  const onPress = React.useCallback(() => {
    if (loading) {
      return;
    }
    pOnPress?.();
  }, [loading, pOnPress]);

  return (
    <Button className={className} disabled={disabled} onPress={onPress}>
      {loading ? <CircularProgress size="1em" color="inherit" /> : children}
    </Button>
  );
};

export default DialogFooterButton;
